/*
 * @Author: Alan
 * @Date: 2023-02-16 15:34:36
 * @LastEditors: Connie
 * @LastEditTime: 2023-08-22 14:12:54
 * @Description: 头部注释
 * @FilePath: \F1-M2-WEB-Code\components\OTP\ReadMore.js
 */
import React from "react";
import { Row, Col, Button } from "antd";

const loginOTP_text = () => {
    return (
        <>
            <div>
                ขอเรียนแจ้งให้ท่านทราบว่าขณะนี้เว็บไซต์ FUN88
                ได้ทำการเพิ่มระดับการรักษา
                ความปลอดภัยของข้อมูลบัญชีเพื่อการรักษามาตรฐานการบริการสูงสุดให้กับ
                สมาชิกดังนั้นจึงขอความร่วมมือจากท่านสมาชิกทำการยืนยันข้อมูลเบอร์โทรศัพท์
                และอีเมลที่ลงทะเบียนเพื่อความปลอดภัยสูงสุดของบัญชีโดยทำการยืนยัน
                หมายเลข OTP 6 หลักที่ส่งไปยังเบอร์โทรศัพท์
                และอีเมลที่ท่านได้ลงทะเบียนไว้
                <br /> กับเรา ทำการยืนยันรหัส OTP 6
                หลักตามขั้นตอนที่เว็บไซต์กำหนดหากท่านไม่
                สามารถทำการยืนยันข้อมูลเบอร์โทรศัพท์หรืออีเมลได้กรุณาติดต่อเจ้าหน้าที่ฝ่าย
                บริการเพื่อให้ความช่วยเหลือ ได้ตลอด 24 ชั่วโมง
            </div>
            <br />
            <p>
                ขอให้ท่านมั่นใจว่าเราจะเก็บรักษาข้อมูลส่วนบุคคลของท่านอย่างเคร่งครัดและจะ
                <br />
                ไม่ทำการเผยแพร่ข้อมูลใดๆหากไม่ได้รับการอนุญาต
                และเราหวังเป็นอย่างยิ่งว่า
                <br />
                จะได้รับความร่วมมือจากสมาชิกในการยืนยันข้อมูลกับทางเว็บไซต์ในครั้งนี้
            </p>
        </>
    );
};
const resetPwd_text = () => {
    return (
        <div>
            เพื่อรักษามาตรฐานการให้บริการสูงสุดกับคุณเรากำลังอัปเกรดระบบรักษาความ
            ปลอดภัยข้อมูลทางเราขอความร่วมมือของคุณในการเปลี่ยนรหัสผ่านใหม่เพื่อ
            พัฒนาความปลอดภัยของคุณ เราขอแนะนำให้คุณใส่สัญลักษณ์อย่างน้อยหนึ่ง
            อย่างต่อไปนี้ “^#%@“
            ในรหัสผ่านของคุณเพื่อปกป้องข้อมูลของคุณเพิ่มเติม
            <br />
            เราจะต้องมีการยืนยันผ่านทาง SMS หรือ
            อีเมลของคุณเพื่อให้เราสามารถช่วย ยืนยันการเข้าสู่ระบบของคุณทันทีที่
            คุณเข้าสู่ระบบเราจะส่งรหัสยืนยันความถูก ต้อง 6 หลักไปยังโทรศัพท์
            หรืออีเมลของคุณที่บันทึกไว้กับเรา คุณสามารถยืนยัน
            บัญชีของคุณได้โดยการระบุรหัส 6 หลักบนหน้าเว็บหากคุณไม่สามารถยืนยัน
            หมายเลขโทรศัพท์หรืออีเมลของคุณได้กรุณาติดต่อห้องแชทสดหรืออีเมล
            cs.thaifun@gmail.com เราพยายามอย่างเต็มที่เพื่อปกป้องข้อมูลส่วนบุคคล
            ของคุณและเราหวังว่าจะได้รับความร่วมมือและความช่วยเหลือจากคุณ
        </div>
    );
};
function ReadMore({ VerifyCategory, setReadStep, kindOfVerification }) {
    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <img
                        className="otp-modal-banner"
                        src="/th/img/user/otpVerify/otp-banner.jpg"
                        alt=""
                    />
                    <div className="otp-modal-description">
                        <div>เรียน สมาชิก FUN88,</div>
                        <br />
                        {kindOfVerification === "OTP"
                            ? loginOTP_text()
                            : resetPwd_text()}
                        <br />
                        <p style={{ margin: 0 }}>ขอแสดงความนับถือ</p>
                        <p style={{ margin: 0 }}>ทีมงาน FUN88</p>
                    </div>
                </Col>
            </Row>

            <Button
                size="large"
                className="otpBtn readMore"
                onClick={() => {
                    setReadStep(0);
                }}
                block
            >
                ดำเนินการตรวจสอบ{/* 进行验证 */}
            </Button>
        </React.Fragment>
    );
}

export default ReadMore;
